<div class="row mt-3 mb-4">
  <ds-banner
    [state]="DsBannerState.info"
    [showTitle]="false"
    [showAction]="false"
    [showCloseButton]="true"
    data-test-id="conformance-report-missing-standard-banner-info"
  >
    <div ds-banner-body>
      {{ 'conformance_report_missing_standard_banner_info' | translate }}
    </div>
  </ds-banner>
</div>

<form [formGroup]="form">
  <div class="row mb-4">
    <div class="col-12">
      <ds-checkbox-group
        [label]="'accessibility_standard' | translate"
        [formControlName]="FormFields.evaluationStandards"
        [required]="true"
        [errorMessage]="evaluationStandardsError$ | async"
        [errorState]="(evaluationStandardsError$ | async)?.length > 0"
        data-test-id="evaluation-standards"
      >
        @for (standard of config?.mainStandardsChoice; track trackByStandard($index, standard)) {
          <ds-checkbox
            (valueChange)="standardClicked($event, standard)"
            [value]="standard"
            [label]="EVALUATION_STANDARD_TO_AUDIT_STANDARD[standard] | translate"
          ></ds-checkbox>
        }
      </ds-checkbox-group>
    </div>
  </div>

  @if (isWcagSelected) {
    <div class="row mb-4">
      <div class="col-12">
        <ds-input
          [label]="'wcag_standard' | translate"
          [required]="true"
          [errorMessage]="wcagStandardsError$ | async"
          [errorState]="(wcagStandardsError$ | async)?.length > 0"
          data-test-id="wcag-standard"
          class="ms-3 ps-4"
        >
          <select ds-input-field [formControlName]="FormFields.wcagStandard">
            <option [ngValue]="null" disabled>{{ 'select_an_option' | translate }}</option>
            @for (standard of config?.wcagStandardConformanceLevels; track trackByStandard($index, standard)) {
              <option [value]="standard">
                {{ getConformanceTranslationKey(standard) | translate }}
              </option>
            }
          </select>
        </ds-input>
      </div>
    </div>
  }
</form>

<div class="row mb-4">
  <div class="col-auto">
    <button class="btn btn-primary" data-test-id="save-button" (click)="onSaveStandardsForm()">
      {{ 'form_save' | translate }}
    </button>
  </div>
</div>
